var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMediumTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4252 39.3431C24.4164 35.6853 24.4164 16.6388 24.4252 12.9824C24.4252 12.6029 24.5911 12.2418 24.8844 11.984C25.1762 11.7277 25.5672 11.6003 25.9627 11.6329C33.3598 12.3112 39.5349 17.8439 39.5349 26.1621C39.5349 34.4802 33.3598 40.013 25.9627 40.6927C25.5672 40.7253 25.1762 40.5964 24.8844 40.3401C24.5911 40.0837 24.4252 39.7212 24.4252 39.3431Z",
    fill: "#FF9E1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6416 44.2008C34.7487 44.2008 42.885 36.1622 42.885 26.3158C42.885 16.4695 34.7487 8.43086 24.6416 8.43086C16.2637 8.43086 9.22804 13.9619 7.07674 21.4648C6.79485 22.448 5.76935 23.0165 4.78621 22.7346C3.80308 22.4527 3.23461 21.4272 3.5165 20.444C6.12201 11.3569 14.607 4.72715 24.6416 4.72715C36.7311 4.72715 46.5887 14.3615 46.5887 26.3158C46.5887 38.2702 36.7311 47.9045 24.6416 47.9045C14.5596 47.9045 6.04167 41.2119 3.47988 32.0584C3.20424 31.0735 3.77921 30.0516 4.76411 29.776C5.74902 29.5003 6.77089 30.0753 7.04654 31.0602C9.16152 38.6173 16.2239 44.2008 24.6416 44.2008Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMediumTime);
export default __webpack_public_path__ + "static/media/ic_medium_time.55c34fac148e5e24014663abac9a42c0.svg";
export { ForwardRef as ReactComponent };